<template>
  <div class="container-fluid">
    <!-- <TopNav 
      :title='$t("user.plural")'
    /> -->
    <div class="row mt-3">
      <div class="col">
        <div class="card">
          <div class="card-body p-0">
            <h6 class="card-title border-bottom p-3 mb-0 header-title">User Overview</h6>
            <div class="row py-1">
                <div class="col-xl-3 col-sm-6">
                    <!-- stat 1 -->
                    <div class="media p-3">
                        <i class="uil-users-alt align-self-center mr-4" style="font-size:30px"></i>
                        <div class="media-body">
                            <h4 class="mt-0 mb-0">{{count.pending}}</h4>
                            <span class="text-muted font-size-13">Pending Invitations</span>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-sm-6" v-if="user.role.role == 'administration'">
                    <!-- stat 2 -->
                    <div class="media p-3">
                        <i class="uil-user-circle align-self-center mr-4" style="font-size:30px"></i>
                        <div class="media-body">
                            <h4 class="mt-0 mb-0">{{count.users}}</h4>
                            <span class="text-muted">Users (Active)</span>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-sm-6" v-if="user.role.role == 'administration'">
                    <!-- stat 3 -->
                    <div class="media p-3">
                        <i class="uil-building align-self-center mr-4" style="font-size:30px"></i>
                        <div class="media-body">
                            <h4 class="mt-0 mb-0">{{count.company}}</h4>
                            <span class="text-muted">Recruitment Company (Active)</span>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-sm-6" v-if="user.role.role == 'administration'">
                    <!-- stat 3 -->
                    <div class="media p-3">
                        <i class="uil-user align-self-center mr-4" style="font-size:30px"></i>
                        <div class="media-body">
                            <h4 class="mt-0 mb-0">{{count.individual}}</h4>
                            <span class="text-muted">Individuals (Active)</span>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
            <!-- <Table 
              ref="table" 
              :initialLoad="false"
            /> -->
            <User @onInvited="load"/>
            <!-- <b-tabs>
              <b-tab title="Users" :active="activeTab('users')"  v-if="user.role.role == 'administration'">
              </b-tab>
              <b-tab title="Recruitment Company" v-if="user.role.role == 'administration'" :active="activeTab('company')">
                <Company @Company="load"/>
              </b-tab>
              <b-tab :title="user.role.role == 'administration' ? 'Individual Recruiter' : 'Recruiter'" :active="activeTab('individual')">
                <Individual @Individual="load"/>
              </b-tab>
            </b-tabs> -->
          </div>
        </div>
  </div>
</template>

<script>
import User from './user'
// import Company from './company'
// import Individual from './individual'

export default {
  components: { User },
  data(){
    return {
      count: {}
    }
  },
  methods:{
    activeTab(typ){
      var tab = this.$route.query.tab || 'users'
      return tab == typ
    },
    load(){
      this.$store.dispatch('user/dashboard').then(res => {
        this.count = res.data
      })
    }
  },
  beforeMount(){
    this.load()
  }
}

</script>